import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Button from "../../../components/base-components/ButtonBase";
import Input from "../../../components/base-components/Input";
import TextArea from "../../../components/base-components/TextArea";

interface ContactFormProps {
  subject: string | null;
  formRef: React.RefObject<HTMLFormElement>;
}

const ContactForm: React.FC<ContactFormProps> = ({ subject, formRef }) => {
  const [ref, inView] = useInView({ threshold: 0.2 });
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!subject) {
      setError("Please apply for a job position to pick a subject");
      return;
    }

    setError(null);
  };

  return (
    <motion.div
      ref={ref}
      className="md:pl-[4rem] flex flex-col w-full md:w-1/2"
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      <h5 className="mb-[2.3rem]">Contact Form</h5>
      <form
        className="w-full flex flex-col justify-between h-full"
        onSubmit={handleSubmit}
        ref={formRef}
      >
        <div className="relative">
          <Input
            topLabel="Subject"
            name="subject"
            placeholder="Pick a Subject"
            value={subject || ""}
            required
            disabled
          />
          {error && <p className="text-rose-500 mt-1">{error}</p>}
        </div>
        <Input
          topLabel="Full Name"
          placeholder="Enter your name"
          name="full_name"
          required
        />
        <Input
          type="email"
          placeholder="Enter your Email"
          topLabel="Email"
          name="email"
          required
        />
        <TextArea
          label="Message"
          placeholder="Enter your message"
          name="message"
          required
        />
        <Button type="submit">
          <p>Submit</p>
        </Button>
      </form>
    </motion.div>
  );
};

export default ContactForm;
